import React, { Component } from "react";
import { Form, Input, Button, notification, Icon } from "antd";
import { Redirect } from "react-router-dom";
import axios from "axios";
import Header from "../User/Header";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        iconLoading: false
    });
};

class RecuperarPassword extends Component {
    state = {
        confirmDirty: false,
        redirect: false,
        redirectLink: "",
        iconLoading: false
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    getParameterByName = name => {
        var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    };

    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue("novaPassword")) {
            callback("Senhas não coincidentes");
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(["confirmarPassword"], { force: true });
        }
        callback();
    };

    handleSubmit = event => {
        event.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.handleChangePassword(values.novaPassword);
            }
        });
    };

    handleConfirmBlur = e => {
        const { value } = e.target;

        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    handleChangePassword = password => {
        this.setState({ iconLoading: true });
        axios({
            method: "put",
            url: "/api/autenticacaonew/alterar-senha",
            params: {
                userId: this.getParameterByName("userId"),
                code: this.getParameterByName("code"),
                new_password: password
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Senha alterada!");
                this.setState({
                    redirect: true,
                    redirectLink: "/login",
                    iconLoading: false
                });
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível alterar a senha!");
                this.setState({
                    redirect: true,
                    redirectLink: "/login",
                    iconLoading: false
                });
            });
    };

    render() {
        const { redirect, redirectLink, iconLoading } = this.state;
        const { getFieldDecorator } = this.props.form;
        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <>
                <Header titulo="Alterar Senha" />
                <Form className="login" onSubmit={this.handleSubmit}>
                    <div className="bloco-alerta">
                        <span className="icon-alerta">
                            <Icon type="info-circle" />
                        </span>
                        <span className="mensagem-alerta">
                            Para poder continuar a utilizar a stepforma em segurança necessita de alterar a sua senha.
                        </span>
                    </div>
                    <div className="recuperar-password">
                        <Form.Item>
                            {getFieldDecorator("novaPassword", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    },
                                    {
                                        pattern: "^(?=.*[A-Z])(?=.*[0-9])(?=.{6,})",
                                        message: (
                                            <p>A senha deve conter pelo menos uma letra maiúscula, um número e um mínimo de 6 caracteres</p>
                                        )
                                    },
                                    {
                                        validator: this.validateToNextPassword
                                    }
                                ]
                            })(<Input.Password type="password" placeholder="Nova senha" onBlur={this.handleConfirmBlur} />)}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator("confirmarPassword", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    },
                                    {
                                        validator: this.compareToFirstPassword
                                    }
                                ]
                            })(<Input.Password type="password" placeholder="Confirmar senha" />)}
                        </Form.Item>
                    </div>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button" disabled={iconLoading}>
                            {iconLoading ? <Icon type="loading" /> : null}
                            Alterar e Continuar
                        </Button>
                    </Form.Item>
                </Form>
            </>
        );
    }
}
const FormRecuperarPassword = Form.create({ name: "recuperar-password" })(RecuperarPassword);

export default FormRecuperarPassword;
